import type { IsoDate, IsoDateTime } from '@omnipresentgroup/design-system';

export type EmploymentScope = 'employee' | 'company';

export enum EmploymentType {
  EOR = 'EOR',
  PEO = 'PEO',
  VIRTUAL_EMPLOYER = 'Virtual Employer',
}

export enum EmploymentStatus {
  CREATED = 'EMPLOYMENT_STATUS_CREATED',
  ONBOARDED = 'EMPLOYMENT_STATUS_ONBOARDED',
  ACTIVE = 'EMPLOYMENT_STATUS_ACTIVE',
  INACTIVE = 'EMPLOYMENT_STATUS_INACTIVE',
}

export type Employment = {
  id: string;
  userId: string;
  type: EmploymentType;
  companyId?: string;
  lspId?: string;
  lspName?: string;
  status: EmploymentStatus;
  startDate?: IsoDate;
  terminationDate?: IsoDate;
  firstPayrollDate?: IsoDate;
  lastPayrollDate?: IsoDate;
  createdAt: IsoDateTime;
  lastUpdatedAt: IsoDateTime;
  activeAt?: IsoDateTime;
  inactiveAt?: IsoDateTime;
  legalEntityId?: string;
};

export const EmploymentStatusMap: { [key: string]: string } = {
  [EmploymentStatus.CREATED]: 'Onboarding',
  [EmploymentStatus.ONBOARDED]: 'Onboarded',
  [EmploymentStatus.ACTIVE]: 'Active',
  [EmploymentStatus.INACTIVE]: 'Inactive',
};
